import type React from 'react';
import { cn } from '../../utils/cn.ts';

export interface FilterBarProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'role'> {
    ariaLabel?: string;
    children: React.ReactNode;
}

export const FilterBar: React.FC<FilterBarProps> = ({
    ariaLabel = 'Filters',
    children,
    className,
    ...props
}) => (
    // biome-ignore lint/a11y/useSemanticElements: The search landmark is intentional; the native search element is not supported by the current test/browser target.
    <div
        aria-label={ariaLabel}
        className={cn(
            'grid grid-cols-1 items-end gap-3 sm:grid-cols-2 lg:grid-cols-4',
            className
        )}
        role="search"
        {...props}
    >
        {children}
    </div>
);

FilterBar.displayName = 'FilterBar';
